<template>
  <page-section title="Publications">
    <trombi :list="sc.publications">
    </trombi>
  </page-section>
</template>
<script>
import pageSection from '@/components/pagesection'
import trombi from '@/components/valuation/trombi'
import sc from '@/sc/valuation'

export default {
  name: 'publications',
  props: {
    publications: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      sc: sc
    }
  },

  components: {
    'page-section': pageSection,
    'trombi': trombi
  }
}
</script>
